<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import solicitacaoAdiantamentoServico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import DadosViagem from './compartilhado/FormDadosViagem.vue';
  import DeclararDespesasRubricas from './compartilhado/FormDeclararDespesasRubricas.vue';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosBancarios, DadosViagem, DeclararDespesasRubricas, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        animated: true,
        tipoDocumento: 'CPF',
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Adiantamento - Declaração de despesas`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-adiantamento.nova';

      $('#tab-dados-cadastrais, #tab-dados-pagamento, #tab-dados-bancarios, #tab-dados-viagem').find('input, select, textarea').attr('disabled', '');
    },
    methods: {
      camposSolicitacao() {
        return {
          idProjeto: null,
          nomeRequerinte: '',
          cpf: '',
          email: null,
          telefone: '',
          celular: '',
          agencia: '',
          banco: '',
          conta: '',
          tipoConta: '',
          despesasViajem: [],
          prestacaoRealizada: null,
          adiantamentoViagem: 1,
          formaPagamento: '',
          dataPagamento: '',
          localidade: '',
          dataPartida: '',
          dataRetorno: '',
          finalidadeViagem: '',
          projeto: {
            nomeProjeto: ''
          }
        }
      },
      salvar() {
        $('#salvar').button('loading');

        if(!this.validarArquivos()) {
          $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

          this.$swal(
            '',
            'É necessário anexar pelo menos um arquivo ',
            'info'
          );

          $('#salvar').button('reset');

          return;
        }

        this.enviar()
          .then(id => {
            this.$imprimirRelatorio('solicitacao-adiantamento.relatorio', id, 'solicitacao-adiantamento');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar() {
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        const arquivos = this.$refs.adicionarArquivos.arquivos;

        return solicitacaoAdiantamentoServico.declararDespesas(copiaSolicitacao, arquivos, this.$route.params.id);
      },
      habilitarDesabilitarProjeto() {
        $('#projeto').prop('disabled', this.solicitacao.despesasViajem.length > 0);
      },
      download(arquivo) {
        solicitacaoAdiantamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoAdiantamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.cpf);
          })
          .then(() => solicitacaoAdiantamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
            solicitacao.cpf.length === 14 ? this.$set(this, 'tipoDocumento', 'CPF') : this.$set(this, 'tipoDocumento', 'CNPJ');
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      validarArquivos() {
        if (!this.configuracao.usarArquivosSolicitacaoAdiantamento)
          return true;

        if (this.configuracao.obrigatorioAnexarArquivoDeclaracao) {
          var existeArquivo = false;

          for (var i = 0; i < this.$refs.adicionarArquivos.arquivos.length; i++) {
            if (this.$refs.adicionarArquivos.arquivos[i]) {
              existeArquivo = true;
              break;
            }
          }

          return existeArquivo;
        }
        else
          return true;
      },
    },
    computed: {
      permitirDeclaracao() {
        let permitir = true;

        this.solicitacao.despesasViajem.map(despesa => {
          despesa.rateios.map(rateio => {
            if (rateio.validade === 1) {
              permitir = false;
            }
          });
        });

        return permitir;
      }
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
      }
      
      this.$events.$on('desativarAnimacao', () => this.animated = false);
    },
    watch: {
      'solicitacao.despesasViajem.length': 'habilitarDesabilitarProjeto'
    },
    beforeDestroy() {
      this.$events.$off('desativarAnimacao');
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <form @submit.prevent="validarBeneficiario">

      <div class="row">
        
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
        </div>

        <div class="tabs-container" v-show="!carregando" id="tabs">
          <ul class="nav nav-tabs">
            <li class="active">
              <a
                data-toggle="tab"
                href="#tab-dados-cadastrais">
                Dados cadastrais
              </a>
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#tab-dados-pagamento">
                Dados para pagamento
              </a>
            </li>
            <li :class="{'disabled': solicitacao.formaPagamento !== 0}">
              <a
                @click.prevent=""
                :data-toggle="solicitacao.formaPagamento === 0 ? 'tab' : ''"
                href="#tab-dados-bancarios">
                Dados bancários
              </a>
            </li>
            <li :class="{'disabled': solicitacao.adiantamentoViagem !== 1}">
              <a
                @click.prevent=""
                :data-toggle="solicitacao.adiantamentoViagem === 1 ? 'tab' : ''"
                href="#tab-dados-viagem">
                Dados da viagem
              </a>
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#tab-despesas-rubricas">
                Despesas com rubricas
              </a>
            </li>
            <li v-if="configuracao.usarArquivosSolicitacaoAdiantamento">
              <a data-toggle="tab"
                 href="#tab-adicionar-arquivos">
                Adicionar arquivos
              </a>
            </li>
          </ul>
          <div class="tab-content">

            <div id="tab-dados-cadastrais" class="tab-pane active">
              <div class="panel-body">
                <dados-cadastrais ref="dadosCadastrais"
                                  :solicitacao="solicitacao"
                                  :tipoDocumento="tipoDocumento"
                                  :edicao="!!$route.params.id">
                </dados-cadastrais>
              </div>
            </div>

            <div id="tab-dados-pagamento" class="tab-pane">
              <div class="panel-body">
                <dados-pagamento ref="dadosPagamento"
                                 :solicitacao="solicitacao"
                                 :edicao="!!$route.params.id">
                </dados-pagamento>
              </div>
            </div>

            <div id="tab-dados-bancarios" class="tab-pane">
              <div class="panel-body">
                <dados-bancarios ref="dadosBancarios"
                                 :solicitacao="solicitacao"
                                 :edicao="!!$route.params.id"
                                 :dadosBancarios="dadosBancarios">
                </dados-bancarios>
              </div>
            </div>

            <div id="tab-dados-viagem" class="tab-pane">
              <div class="panel-body">
                <dados-viagem ref="dadosViagem"
                              :solicitacao="solicitacao"
                              :edicao="!!$route.params.id">
                </dados-viagem>
              </div>
            </div>

            <div id="tab-despesas-rubricas" class="tab-pane">
              <div class="panel-body">
                <declarar-despesas-rubricas ref="despesasRubricas"
                                            :solicitacao="solicitacao"
                                            :permitirDeclaracao="permitirDeclaracao"
                                            :edicao="!!$route.params.id">
                </declarar-despesas-rubricas>
              </div>
            </div>

            <div id="tab-adicionar-arquivos" class="tab-pane">
              <div class="panel-body">
                <adicionar-arquivos ref="adicionarArquivos">
                </adicionar-arquivos>
              </div>
            </div>

          </div>
        </div>
        
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'solicitacao-adiantamento' }"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>
            
            <button
              v-if="permitirDeclaracao && !carregando"
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/SolicitacaoAdiantamentoDeclaracaoDespesas.vue